import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderData } from '../../_models/header-data';
import { Submission } from '../_models/submission';
import { FILE_UPLOAD_CONFIG, FORM_MSGS } from 'src/app/_common/product-config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubmissionSteps, ClearAccountIndicators, CoverageStatus, NewBusiness } from '../../_common/_enum/module.enum';
import { SubmissionAttachmentsComponent } from '../submission-attachments/submission-attachments.component';
import { SubmissionReviewComponent } from '../submission-review/submission-review.component';
import { SubmissionsService } from '../_services/submissions.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import LogRocket from 'logrocket';

@Component({
  selector: 'app-view-submission',
  templateUrl: './view-submission.component.html',
  styleUrls: ['./view-submission.component.scss']
})
export class ViewSubmissionComponent implements OnInit {
  
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  private submissionId: string;

  public loading: boolean = false; //Using it in HTML
  public uloading: boolean = false; //Using it in HTML
  private isSubmitted: boolean = false;

  private _submission: Submission;
  private submissionSteps = SubmissionSteps;

  private showDocumentSuccess: boolean = false;

  private formMsgs = FORM_MSGS; //using it in HTML
  private fileUploadConfig = FILE_UPLOAD_CONFIG; //Using it in HTML

  private modalReference;
  
  private uploadedFileSize: number = 0;

  @ViewChild("discardSubmissionAttachmentsModal", {static: false}) discardSubmissionAttachmentsModal;
  @ViewChild(SubmissionReviewComponent, {static: false}) submissionDetails:SubmissionReviewComponent;
  @ViewChild(SubmissionAttachmentsComponent, {static: false}) submissionAttachments:SubmissionAttachmentsComponent;
  constructor(private readonly route: ActivatedRoute, private submissionService: SubmissionsService, private modalService : NgbModal, private readonly router: Router) { }

  ngOnInit() {
    this.fetchReferenceData();
    this.submissionService.resetSupportingDocuments();
    this._submission = new Submission();
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    /* Setting Headers Ended */

    //Getting Policy Number for State params
    this.route.paramMap.subscribe(params => {      
      if(this.submissionId !== params.get("id").toString()){
        this.submissionId = params.get("id").toString();
      }
      this.fetchSubmissionDetails();
    });
    
    if(history && history.state && history.state.showAttachments == true){
      //this.selectedStep = SubmissionSteps.Attachments;
      this._submission.selectedStep = SubmissionSteps.Attachments;
    }
  }
  setHeaderData(){
    this.headerData.pageTitle = this._submission.submissionData.accountName; //static for now (company legal name)
    this.headerData.breadcrumb = [{itemName: "❮ Back to List", itemLink: "../newbusiness"}];

    this.submissionService.header = this.headerData;
  }

  selectStep(_step){
      this.selectedStep = _step;
    this._submission.selectedStep = this.selectedStep;

    this.submission = this._submission;
  }

  fetchReferenceData(){
    let lookupSubscription =  this.submissionService.fetchReferenceData().subscribe(response=>{
    }, error=>{
    });

    this.submissionService.runningServices.push(lookupSubscription);
  }

  fetchSubmissionDetails(){
    this.loading = true;
    let submissionDetailsSubscription = this.submissionService.fetchSubmissionDetails(this.submissionId).subscribe(response => {
      this.loading = false;
      this._submission.isExistingAccount = (response.accountIndicator === ClearAccountIndicators.DUPLICATE);
      this._submission.submissionData = response;

      let openCoverage = this._submission.submissionData.coverages.find(_coverage => {return _coverage.displayStatus == CoverageStatus.InReview || _coverage.displayStatus == CoverageStatus.Reserved});
      this._submission.allowAttachments = openCoverage!=undefined;
      this._submission.submissionData.primaryContactNotProvided = (response.contact == null || !response.contact.firstName);
      this.setHeaderData();
      this.submission = this._submission;
        
      if(this._submission.selectedStep){
        this.selectedStep = this._submission.selectedStep;
      }else{
        this._submission.selectedStep = SubmissionSteps.SubmissionDetails;
      }
      this.submission = this._submission;

    },error=>{
        this.loading = false;
    });

    this.submissionService.runningServices.push(submissionDetailsSubscription);
  }

  get hasAnyDocumentSelected(){
    return this.submissionService.getSupportingDocuments().length > 0;
  }

  get selectedStep(){
    return this.submissionService.selectedStep;
  }
  set selectedStep(_step){
    this._submission.selectedStep = _step;
    this.submissionService.selectedStep = _step;
  }
  get submission(){
    return this.submissionService.submission;
  }
  set submission(_submission){
    this.submissionService.submission = _submission;
  }

  getUploadedFileSize($event) {
    this.uploadedFileSize = $event;
  }

  onDiscard(){
    this.modalReference = this.modalService.open(this.discardSubmissionAttachmentsModal, { centered: true, backdropClass: 'light-blue-backdrop' });
    this.modalReference.result.then((result) => {
      console.log("closed");
      }, (reason) => {
        console.log("dismissed");
    });
  }

  discardAttachments(){
    this.modalReference.close();
    this.router.navigate(["newbusiness"], {state: {selectedBusiness: NewBusiness.SUBMISSIONS}});
  }

  onContinue(){
    this.isSubmitted = true;
    if(this.selectedStep == SubmissionSteps.Attachments){
      if(this.submissionAttachments.onContinue()){
        this.submission = this._submission;

        console.log("uploading files");
        let newSupportingDocuments = [];
        this.uloading = true;
        let supportedDocuments = this.submissionService.getSupportingDocuments();
        if(supportedDocuments.length>0){
          supportedDocuments.forEach((document, index) => {
            let newFile:any = {};
              newFile.fileName= document.name;
              newFile.fileType= document.type;
              newFile.documentType = document.documentType;

              ((_document, _newFile)=>{
                let fReader = new FileReader();
                // Add complete behavior
                fReader.onload = ()=>{
                  _newFile.contentStream = fReader.result;
                  _newFile.contentStream = _newFile.contentStream.split("base64,")[1];

                  //console.log(_newFile.contentStream);
                  newSupportingDocuments.push(_newFile);

                  if(newSupportingDocuments.length == supportedDocuments.length){
                    this.uploadDocuments(newSupportingDocuments);
                  }else{
                    console.log("uploading file " + index);
                  }
                };
                fReader.readAsDataURL(_document);
              })(document, newFile);   
          });
        }else{
          //this.uploadDocuments([]);
          console.log("trying to submit wihtout any documents");
        }
      }
    }
  }

  uploadDocuments(newSupportingDocuments){
    console.log("Submitting request");
    this.showDocumentSuccess = false;
    let documentRequestPayload = {"applicationId" : this.submissionId, "applicationType": "sc", "attachments": newSupportingDocuments}

    this.submissionService.uploadDocuments(documentRequestPayload).subscribe(()=>{
      console.log("Uploaded!!");
      this.uloading = false;
      this.showDocumentSuccess = true;

      this.submissionService.resetSupportingDocuments();
      let submissionData = this._submission.submissionData;
      newSupportingDocuments.forEach(_doc => {
        let newDocument = {createdDate: new Date().toLocaleString(),
        documentType: _doc.documentType,
        fileName: _doc.fileName,
        fileType: _doc.fileType}

        submissionData.attachments.push(newDocument);
      });
      //submissionData.attachments.concat(newSupportingDocuments);
      this.submission.submissionData = submissionData;
      this.submission = this._submission;

      window.scrollTo(0, document.body.scrollHeight);

      if(environment.logRocketKey){
        LogRocket.log("(LogRocket) AdditionalDocumentsUploaded : " + true);
        let loggedInUser = this.submissionService.getLoggedInProfile();
        LogRocket.identify(loggedInUser.UID.toString(), {
          SubmissionRequestSubmitted: true
        });
      }
    },error=>{          
      this.uloading = false;
      this.submissionService.resetSupportingDocuments();
    });
  }
}
